module.exports = __webpack_public_path__ + "static/formPersonal-d130b3a21a9bd5e75e7c652f69858a31.jpg";